import { BsArrowBarLeft } from '@react-icons/all-files/bs/BsArrowBarLeft.js';
import { BsArrowBarRight } from '@react-icons/all-files/bs/BsArrowBarRight.js';
import { BsLayersFill } from '@react-icons/all-files/bs/BsLayersFill.js';
import { BsStars } from '@react-icons/all-files/bs/BsStars.js';
import { CgSidebarOpen } from '@react-icons/all-files/cg/CgSidebarOpen.js';
import { CgSidebarRight } from '@react-icons/all-files/cg/CgSidebarRight.js';
import { FaChevronDown } from '@react-icons/all-files/fa/FaChevronDown.js';
import { FaFileDownload } from '@react-icons/all-files/fa/FaFileDownload.js';
import { FaRedditSquare } from '@react-icons/all-files/fa/FaRedditSquare.js';
import { FaSalesforce } from '@react-icons/all-files/fa/FaSalesforce.js';
import { FaSlack } from '@react-icons/all-files/fa/FaSlack.js';
import { FaTelegram } from '@react-icons/all-files/fa/FaTelegram.js';
import { FaSquareXTwitter } from '@react-icons/all-files/fa6/FaSquareXTwitter.js';
import { FiColumns } from '@react-icons/all-files/fi/FiColumns.js';
import { MdAdd } from '@react-icons/all-files/md/MdAdd.js';
import { MdArrowBack } from '@react-icons/all-files/md/MdArrowBack.js';
import { MdArrowDropDown } from '@react-icons/all-files/md/MdArrowDropDown.js';
import { MdArrowForward } from '@react-icons/all-files/md/MdArrowForward.js';
import { MdBolt } from '@react-icons/all-files/md/MdBolt.js';
import { MdCheck } from '@react-icons/all-files/md/MdCheck.js';
import { MdClose } from '@react-icons/all-files/md/MdClose.js';
import { MdDragIndicator } from '@react-icons/all-files/md/MdDragIndicator.js';
import { MdEmail } from '@react-icons/all-files/md/MdEmail.js';
import { MdErrorOutline } from '@react-icons/all-files/md/MdErrorOutline.js';
import { MdFileDownloadDone } from '@react-icons/all-files/md/MdFileDownloadDone.js';
import { MdFilterList } from '@react-icons/all-files/md/MdFilterList.js';
import { MdHelpOutline } from '@react-icons/all-files/md/MdHelpOutline.js';
import { MdInfoOutline } from '@react-icons/all-files/md/MdInfoOutline.js';
import { MdLanguage } from '@react-icons/all-files/md/MdLanguage.js';
import { MdLink } from '@react-icons/all-files/md/MdLink.js';
import { MdModeEditOutline } from '@react-icons/all-files/md/MdModeEditOutline.js';
import { MdMoreVert } from '@react-icons/all-files/md/MdMoreVert.js';
import { MdOutlineHistory } from '@react-icons/all-files/md/MdOutlineHistory.js';
import { MdOutlinePlaylistAdd } from '@react-icons/all-files/md/MdOutlinePlaylistAdd.js';
import { MdOutlineSmartToy } from '@react-icons/all-files/md/MdOutlineSmartToy.js';
import { MdOutlineThumbDown } from '@react-icons/all-files/md/MdOutlineThumbDown.js';
import { MdOutlineThumbUp } from '@react-icons/all-files/md/MdOutlineThumbUp.js';
import { MdOutlineWarningAmber } from '@react-icons/all-files/md/MdOutlineWarningAmber.js';
import { MdPerson } from '@react-icons/all-files/md/MdPerson.js';
import { MdPhone } from '@react-icons/all-files/md/MdPhone.js';
import { MdRemove } from '@react-icons/all-files/md/MdRemove.js';
import { MdShare } from '@react-icons/all-files/md/MdShare.js';
import { PiCalendarDotsLight } from '@react-icons/all-files/pi/PiCalendarDotsLight.js';
import { PiCloud } from '@react-icons/all-files/pi/PiCloud.js';
import { PiCloudFog } from '@react-icons/all-files/pi/PiCloudFog.js';
import { PiCloudLightning } from '@react-icons/all-files/pi/PiCloudLightning.js';
import { PiCloudMoon } from '@react-icons/all-files/pi/PiCloudMoon.js';
import { PiCloudRain } from '@react-icons/all-files/pi/PiCloudRain.js';
import { PiCloudSnow } from '@react-icons/all-files/pi/PiCloudSnow.js';
import { PiCloudSun } from '@react-icons/all-files/pi/PiCloudSun.js';
import { PiDiamondsFour } from '@react-icons/all-files/pi/PiDiamondsFour.js';
import { PiFilePdf } from '@react-icons/all-files/pi/PiFilePdf.js';
import { PiListMagnifyingGlass } from '@react-icons/all-files/pi/PiListMagnifyingGlass.js';
import { PiMapPinLineLight } from '@react-icons/all-files/pi/PiMapPinLineLight.js';
import { PiMoon } from '@react-icons/all-files/pi/PiMoon.js';
import { PiMoonStars } from '@react-icons/all-files/pi/PiMoonStars.js';
import { PiSun } from '@react-icons/all-files/pi/PiSun.js';
import { PiSunHorizon } from '@react-icons/all-files/pi/PiSunHorizon.js';
import { PiTable } from '@react-icons/all-files/pi/PiTable.js';
import { PiTabsFill } from '@react-icons/all-files/pi/PiTabsFill.js';
import { PiTag } from '@react-icons/all-files/pi/PiTag.js';
import { PiWaveform } from '@react-icons/all-files/pi/PiWaveform.js';
import { RxCopy } from '@react-icons/all-files/rx/RxCopy.js';
import { RxExternalLink } from '@react-icons/all-files/rx/RxExternalLink.js';
import { VscSymbolKeyword } from '@react-icons/all-files/vsc/VscSymbolKeyword.js';
import Bluesky from './icons/Bluesky.js';
import Bolt from './icons/Bolt.js';
import BoltWithOutline from './icons/BoltWithOutline.js';
import BoltWithS from './icons/BoltWithS.js';
import Broadcastify from './icons/Broadcastify.js';
import Citizen from './icons/Citizen.js';
import DarkWeb from './icons/DarkWeb.js';
import Facebook from './icons/Facebook.js';
import IncidentStream from './icons/IncidentStream.js';
import Instagram from './icons/Instagram.js';
import Nextdoor from './icons/Nextdoor.js';
import PrivateIncident from './icons/PrivateIncident.js';
import ProMed from './icons/ProMed.js';
import WebAlertStream from './icons/WebAlertStream.js';
import Weibo from './icons/Weibo.js';

const iconMap = {
    /* Standard icons */
    add: MdAdd,
    addRow: MdOutlinePlaylistAdd,
    arrowBarLeft: BsArrowBarLeft,
    arrowBarRight: BsArrowBarRight,
    arrowDown: MdArrowDropDown,
    assetSets: PiDiamondsFour,
    back: MdArrowBack,
    calendar: PiCalendarDotsLight,
    check: MdCheck,
    chevronDown: FaChevronDown,
    close: MdClose,
    columns: FiColumns,
    copy: RxCopy,
    download: FaFileDownload,
    downloadDone: MdFileDownloadDone,
    dragIndicator: MdDragIndicator,
    edit: MdModeEditOutline,
    email: MdEmail,
    error: MdErrorOutline,
    externalLink: RxExternalLink,
    filePdf: PiFilePdf,
    filter: MdFilterList,
    forward: MdArrowForward,
    history: MdOutlineHistory,
    incidentType: PiTag,
    info: MdInfoOutline,
    keyword: PiListMagnifyingGlass,
    link: MdLink,
    location: PiMapPinLineLight,
    mapSettings: BsLayersFill,
    minus: MdRemove,
    more: MdMoreVert,
    person: MdPerson,
    phone: MdPhone,
    reddit: FaRedditSquare,
    salesforce: FaSalesforce,
    severity: PiWaveform,
    share: MdShare,
    sidebarCollapse: CgSidebarRight,
    sidebarExpand: CgSidebarOpen,
    slack: FaSlack,
    impactAgent: MdOutlineSmartToy,
    standardBolt: MdBolt,
    stars: BsStars,
    streamLocked: VscSymbolKeyword,
    sunrise: PiSunHorizon,
    sunset: PiMoonStars,
    table: PiTable,
    tabs: PiTabsFill,
    telegram: FaTelegram,
    thumbDown: MdOutlineThumbDown,
    thumbUp: MdOutlineThumbUp,
    twitter: FaSquareXTwitter,
    unknown: MdHelpOutline,
    warning: MdOutlineWarningAmber,
    weatherClear: PiSun,
    weatherClearNight: PiMoon,
    weatherCloudy: PiCloud,
    weatherFog: PiCloudFog,
    weatherPartlyCloudy: PiCloudSun,
    weatherPartlyCloudyNight: PiCloudMoon,
    weatherRain: PiCloudRain,
    weatherSnow: PiCloudSnow,
    weatherThunderstorm: PiCloudLightning,
    web: MdLanguage,
    x: FaSquareXTwitter,
    /* Custom icons */
    bluesky: Bluesky,
    bolt: Bolt,
    boltWithOutline: BoltWithOutline,
    boltWithS: BoltWithS,
    broadcastify: Broadcastify,
    citizen: Citizen,
    darkweb: DarkWeb,
    facebook: Facebook,
    incidentStream: IncidentStream,
    instagram: Instagram,
    nextdoor: Nextdoor,
    privateIncident: PrivateIncident,
    promed: ProMed,
    samdesk: BoltWithOutline,
    webAlertStream: WebAlertStream,
    weibo: Weibo,
};

export { iconMap };
//# sourceMappingURL=iconMap.js.map
